const SESSION_STORAGE_KEYS = {
  TOKEN: "token",
};

export default SESSION_STORAGE_KEYS;
